export default {
  title: 'Erikoistarjoukset',
  header: {
    back: 'Takaisin',
    title: 'Palkinnot',
  },
  info: {
    title: 'Sinulla on {{points}} pistettä.',
    description:
      'Käytä {{amount}} saadaksesi 5 pistettä! Lisää tuotteita ostoskoriin ilmaiseksi ansaitsemillasi pisteillä.',
  },
  rewards: {
    data: [
      {
        title: 'Ansaitse pisteitä jokaisesta tilauksesta',
        description: 'Jokainen käyttämäsi {{amount}} lisää tilillesi 5 pistettä.',
      },
      {
        title: 'Ansaitse pisteitä jokaisesta tilauksesta',
        description:
          'Lunasta pisteesi ilmaisiin herkkuihin! Aloita pisteiden ansaitseminen 350 pisteestä, mikä vastaa {{amount}} käyttämistä.',
      },
      {
        title: 'Ansaitse pisteitä jokaisesta tilauksesta',
        description:
          'Tutustu ainutlaatuisiin tarjouksiin, kampanjoihin ja alennuksiin. Katso jäsenille tarkoitetut kampanjat sovelluksessa.',
      },
    ],
  },
};
